import { useEffect } from "react";
import { JourneySection } from "@/components/journey/JourneySection";

// Standout test space for the journey section. Homepage does not render it yet.
export default function JourneyLab() {
  useEffect(() => {
    document.title = "Journey Lab | Damian Keyes";
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <JourneySection />
      {/* spacer so the sticky scroll region can be scrolled past and the end of the section seen */}
      <div className="h-[60vh] bg-white" />
    </main>
  );
}
